import { render, staticRenderFns } from "./RelationshipPreviousStatus.vue?vue&type=template&id=cddc6a80"
import script from "./RelationshipPreviousStatus.vue?vue&type=script&lang=js"
export * from "./RelationshipPreviousStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports